import "../Styles/Loader.css"

const Loader = ({ loading }:any) => {
  if (!loading) return null;

  return (
    <div className="loader-overlay">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;